import styled from "styled-components";

export const ReadModeContainer = styled.div`
  min-height: 244px;
  max-height: 244px;
  direction: rtl;
  text-align: right;
  padding: 16px 32px;
  overflow-y: auto;
  border: 1px solid var(--bg-gray);
  border-radius: 16px;
  @media (max-width: 1024px) {
    max-height: 244px;
    border: 1px solid #e9ebf8;
    filter: drop-shadow(2px 4px 10px rgba(108, 136, 170, 0.08));
    border-bottom-left-radius: 16px;
    border-bottom-right-radius: 16px;
    padding: 16px 16px;
    min-height: 244px;
  }
  & > div {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    text-align: right;
    span {
      margin-right: 2px;
      height: min-content;
      color: var(--text-500);
      font-size: 14px;
      font-weight: 400;
      line-height: 24.18px;
      &.active {
        background: #d1e6ff;
      }
    }
  }
`;
